import React from 'react';
import { StyleSheet, View } from 'react-native';

import { CloudinaryImage, ORDER_LINE_ITEM_IMAGE_CONFIG } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const OrderAgainConflictReviewImage = (props: OrderAgainConflictReviewImageProps) => {
  const { imageUrl, alt } = props;

  return (
    <View style={styles.container}>
      <CloudinaryImage
        baseUrl={imageUrl}
        contentFit="contain"
        config={ORDER_LINE_ITEM_IMAGE_CONFIG}
        alt={alt}
        style={styles.productImage}
      />
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const PRODUCT_IMAGE = {
  WIDTH: 343,
  HEIGHT: 273,
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  productImage: {
    width: '100%',
    maxWidth: PRODUCT_IMAGE.WIDTH,
    height: PRODUCT_IMAGE.HEIGHT,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type OrderAgainConflictReviewImageProps = {
  imageUrl: string;
  alt?: string;
};
